/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FileTypeTableIcon16Light } from './FileTypeTableIcon16Light';
import { FileTypeTableIcon16Regular } from './FileTypeTableIcon16Regular';
import { FileTypeTableIcon16Solid } from './FileTypeTableIcon16Solid';
import { FileTypeTableIcon20Light } from './FileTypeTableIcon20Light';
import { FileTypeTableIcon20Regular } from './FileTypeTableIcon20Regular';
import { FileTypeTableIcon20Solid } from './FileTypeTableIcon20Solid';
import { FileTypeTableIcon24Regular } from './FileTypeTableIcon24Regular';
import { FileTypeTableIcon24Solid } from './FileTypeTableIcon24Solid';
import { FileTypeTableIcon32Regular } from './FileTypeTableIcon32Regular';
import { FileTypeTableIcon64Regular } from './FileTypeTableIcon64Regular';
var sizes = {
    16: {
        light: FileTypeTableIcon16Light,
        regular: FileTypeTableIcon16Regular,
        solid: FileTypeTableIcon16Solid,
    },
    20: {
        light: FileTypeTableIcon20Light,
        regular: FileTypeTableIcon20Regular,
        solid: FileTypeTableIcon20Solid,
    },
    24: {
        regular: FileTypeTableIcon24Regular,
        solid: FileTypeTableIcon24Solid,
    },
    32: {
        regular: FileTypeTableIcon32Regular,
    },
    64: {
        regular: FileTypeTableIcon64Regular,
    },
};
export var FileTypeTableIcon = forwardRef('FileTypeTableIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
